import React, { useRef } from 'react';
import { Box, Button, ButtonGroup, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ImageIcon from '@mui/icons-material/Image';
import TableChartIcon from '@mui/icons-material/TableChart';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { downloadCSV, downloadPNGFromSVGContainer } from '../../utils/exportUtils';

interface ExportButtonsProps<T> {
  filename: string;
  data?: T[]; // for CSV export
  containerRef?: React.RefObject<HTMLElement>; // for PNG export from SVG
  showPDF?: boolean; // placeholder if PDF added later
}

export default function ExportButtons<T>({ filename, data = [], containerRef, showPDF = false }: ExportButtonsProps<T>) {
  const localContainerRef = useRef<HTMLElement | null>(null);

  const handlePNG = async () => {
    const el = (containerRef?.current || localContainerRef.current) as HTMLElement | null;
    if (!el) return;
    await downloadPNGFromSVGContainer(el, filename);
  };

  const handleCSV = () => {
    if (!data || data.length === 0) return;
    downloadCSV(data as any[], filename);
  };

  return (
    <Box display="flex" justifyContent="flex-end" mb={1}>
      <ButtonGroup variant="outlined" size="small">
        {containerRef && (
          <Tooltip title="Export image">
            <Button onClick={handlePNG} startIcon={<ImageIcon />} aria-label="Export as image">
              PNG
            </Button>
          </Tooltip>
        )}
        {data && data.length > 0 && (
          <Tooltip title="Export table data">
            <Button onClick={handleCSV} startIcon={<TableChartIcon />} aria-label="Export as CSV">
              CSV
            </Button>
          </Tooltip>
        )}
        {showPDF && (
          <Tooltip title="Export to PDF">
            <Button startIcon={<PictureAsPdfIcon />} aria-label="Export as PDF" disabled>
              PDF
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Download">
          <Button startIcon={<DownloadIcon />} disabled>
            All
          </Button>
        </Tooltip>
      </ButtonGroup>
    </Box>
  );
}
